<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="600px"
    :title="title + '对话框'"
    :visible.sync="dialogFormVisible"
  >
    <el-form :model="robotForm" :rules="robotRules" ref="robotForm">
      <el-form-item label="关键字" :label-width="formLabelWidth" prop="keyWord">
        <el-input
          v-model="robotForm.keyWord"
          autocomplete="off"
          placeholder="十个字以内"
        ></el-input>
      </el-form-item>

      <el-form-item label="回答" :label-width="formLabelWidth" prop="answer">
        <el-input v-model="robotForm.answer" autocomplete="off"></el-input>
      </el-form-item>

      <div class="hint">
        标准: 关键词检索不到时，返回所有标准关键词供用户选择
      </div>
      <el-form-item label="类型" :label-width="formLabelWidth" prop="type">
         <el-select class="search-select1" v-model="robotForm.type" placeholder="请选择状态" >
           <el-option  v-for="(item, index) in typeList" :key="index" :label="item.label" :value="item.value" ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit('robotForm')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addChatWordApi, setChatWordApi } from '@/api/newsApi.js'

var validateKeyWord = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入关键字'))
  } else if (value.length > 10) {
    callback(new Error('关键字只能在十个字以内!'))
  } else {
    callback()
  }
}
export default {
  name: 'robotForm',
  data () {
    return {
      formLabelWidth: '80px', // 对话框中 文本的尺寸
      dialogFormVisible: false, // 是否显示对话框
      robotForm: {
        // 编辑表单
        keyWord: '',
        answer: '',
        type: ''
      },
      typeList: [
        { value: 1, label: '标准' },
        { value: 2, label: '普通' }
      ],
      title: '新增',
      robotRules: {
        // 表单的验证规则
        keyWord: [
          { validator: validateKeyWord, required: true, trigger: 'blur' }
        ],
        answer: [{ required: true, message: '请输入回答', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
      }
    }
  },
  methods: {
    submit(formName) {
      try {
        this.$refs.robotForm.validate(async valid => {
          if (!valid) return
          let res = this.title == '新增' ?  await addChatWordApi(this.robotForm) :  await setChatWordApi(this.robotForm)
          if(res.code !== 200) return
          this.$message.success(this.title + '成功!')
          this.dialogFormVisible = false
          // 清空表单
          this.$refs[formName].resetFields()
          this.robotForm = {}
          // 重新请求数据
          this.$emit('refshData')
        })
      } catch (e) {
        window.console.log(e)
      }
    }
  }
}
</script>

<style>

.hint {
  text-align: center;
  color: #bbb;
  font-size: 16px;
  margin-bottom: 10px;
}
</style>
